import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { useState, useEffect } from 'react';
import Select from "react-select";
import SelectCustomStyles from '../../../../../utils/styles/reactSelect';
import { useTranslation } from 'react-i18next';

const EMPTY_FILTERS = {
  subject: '',
  call_type: '',
  min_duration: '',
  max_duration: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({isOpen, toggle, applyFilters, filters = {}}) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({...EMPTY_FILTERS, ...filters});
  
  useEffect(() => {
    if (isOpen) {
      setFiltersData({...EMPTY_FILTERS, ...filters});
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return(
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction="right"
      size={400}
      enableOverlay={true}
      zIndex={9000}
      duration={200}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t('common.filter')}</h4>

        <FormGroup>
          <Label>{t('common.subject')}: </Label>
          <Input
            value={filtersData.subject}
            onChange={(e) => setFiltersData({...filtersData, subject: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.type')}: </Label>
          <Input
            type="select"
            value={filtersData.call_type}
            onChange={(e) => setFiltersData({...filtersData, call_type: e.target.value})}
          >
            <option value="">{t('common.selectType')}</option>
            <option value="inbound">{t('crm.inbound')}</option>
            <option value="outbound">{t('crm.outbound')}</option>
            <option value="missed">{t('common.missed')}</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label>{t('crm.minDurationSeconds')} </Label>
          <Input
            type="number"
            value={filtersData.min_duration}
            onChange={(e) => setFiltersData({...filtersData, min_duration: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('crm.maxDurationSeconds')} </Label>
          <Input
            type="number"
            value={filtersData.max_duration}
            onChange={(e) => setFiltersData({...filtersData, max_duration: e.target.value})}
          />
        </FormGroup>

        <hr />

        <FormGroup>
          <Label>{t('common.addedAfter')} </Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({...filtersData, added_after: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedBefore')} </Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({...filtersData, added_before: e.target.value})}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{marginBottom: '10px'}}>
          {t('common.applyFilters')}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t('common.clearFilters')}
        </DefaultButton>
      </div>
    </Drawer>
  );
}

export default FiltersDrawer;